//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryMethodServices', {
//        templateUrl: 'views/components/views/deliveryMethodServices/deliveryMethodServices.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'deliveryMethodServicesService', function ($stateParams, deliveryMethodServicesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;
            
//            vm.model = {
//                menu: {},
//                itemsListServices: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await deliveryMethodServicesService.getMenu({ deliverymethod_no: deliveryMethodNo }))[0];

//                loadServices();
//            }

//            async function loadServices() {
//                vm.model.itemsListServices = (await deliveryMethodServicesService.listServices(vm.model.menu));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
